<template>
  <div class="event-add-lots">
    <lot-form
      ref="lotData"
      :lot="currentLot"
      :parentOptions="parentOptions"
      @reset-end-date="resetEndDate"
    />

    <button
      class="mt-6 btn px-5 fw-4"
      :class="isValid ? 'btn-primary' : 'btn-new-secondary'"
      :disabled="!isValid"
      @click="saveLot"
    >
      Salvar ingresso
    </button>

    <div v-if="savedLots.length" class="pt-3 mt-6">
      <h4 class="mb-3">Ingressos salvos</h4>
      <div class="lots-box">
        <lot-card
          v-for="(lot, i) in savedLots"
          :key="i"
          :lot="lot"
          :has-children="hasChildren(lot.id)"
          @edit="editLot(i)"
          @delete="deleteLot(i)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import LotCard from "./LotCard";
import LotForm from "./LotForm";
export default {
  components: { LotForm, LotCard },
  props: {
    savedLots: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentLot: {},
      editIndex: undefined
    };
  },
  computed: {
    isValid() {
      const requiredFields = ["name", "stock", "price", "type", "end_at"];
      return (
        !requiredFields.find(f => !this.currentLot[f]) &&
        !!(this.currentLot.parent_id || this.currentLot.start_at)
      );
    },
    parentOptions() {
      return [...this.savedLots]
        .map(({ id, name }) => ({ id, name }))
        .filter((_, index) => index !== this.editIndex);
    }
  },
  methods: {
    hasChildren(id) {
      return !!this.savedLots.find(t => t.parent_id === id);
    },

    resetEndDate() {
      this.currentLot.end_at = "";
    },
    setNewLot() {
      this.currentLot = formFields(
        ["name", "stock", "price", "type", "parent_id", "start_at", "end_at"],
        { type: "by_date" }
      ).form;

      this.$refs.lotData.resetInputs();
    },
    saveLot() {
      const lots = [...this.savedLots];

      if (this.editIndex !== undefined) lots[this.editIndex] = this.currentLot;
      else lots.push({ ...this.currentLot, id: crypto.randomUUID() });

      this.$emit("set-lots", lots);

      this.setNewLot();
      if (this.editIndex !== undefined) this.editIndex = undefined;
    },
    editLot(i) {
      this.currentLot = { ...this.savedLots[i] };
      this.editIndex = i;
    },
    deleteLot(i) {
      const lots = [...this.savedLots];
      lots.splice(i, 1);

      this.$emit("set-lots", lots);

      if (this.editIndex) {
        if (this.editIndex === i) {
          this.editIndex = undefined;
          this.setNewLot();
        } else if (i < this.editIndex) this.editIndex--;
      }
    }
  },
  mounted() {
    this.setNewLot();
  },
  watch: {
    "currentLot.type"(v) {
      if (v == "per_batch") this.currentLot.start_at = "";
      else this.currentLot.parent_id = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.event-add-lots {
  .lots-box {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23D2D0D8FF' stroke-width='2' stroke-dasharray='10 10' stroke-dashoffset='4' stroke-linecap='round'/%3e%3c/svg%3e");
    border-radius: 4px;
    background-color: no-repeat;
    background-color: rgba(255, 255, 255, 0.1);
    width: 100%;
    padding: 16px;
    > *:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}
</style>
